export * from './teleconsult-payment-detail-popup.component';
export * from './teleconsult-payment-detail-popup.module';